import { TOnlineBankWithProvider } from './BankSelectionModal.types';
import { ChooseBank } from './ChooseBank';
import { ConnectBank } from './ConnectBank';
import { LinkedAccount } from './getLinkedAccounts';
import { LinkedAccountsSuccess } from './LinkedAccountsSuccess';
import { TrackingSource } from './trackingSource';
import { ModalStep } from './useBankSelectionFlow';

export const BankSelectionBody = ({
    linkingForBankVerification = false,
    isBankEvidence = false,
    step,
    selectedBank,
    selectBank,
    unselectBank,
    onLinkAnother,
    linkedAccounts = [],
    onDone,
    onOpenShareableLink,
    trackingSource,
    isFundingRequirementsRedesign = false
}: {
    linkingForBankVerification?: boolean;
    isBankEvidence?: boolean;
    step: ModalStep;
    selectedBank: TOnlineBankWithProvider | null;
    selectBank: (bank: TOnlineBankWithProvider) => void;
    unselectBank: () => void;
    onLinkAnother: () => void;
    linkedAccounts?: LinkedAccount[];
    onDone?: () => void;
    onOpenShareableLink?: () => void;
    trackingSource: TrackingSource;
    isFundingRequirementsRedesign?: boolean;
}) => {
    if (step === 'success') {
        return (
            <LinkedAccountsSuccess
                onLinkAnother={onLinkAnother}
                onDone={() => onDone?.()}
            />
        );
    }

    if (step === 'connect' && selectedBank) {
        return (
            <ConnectBank
                selectedBank={selectedBank}
                unselectBank={unselectBank}
                linkingForBankVerification={linkingForBankVerification}
            />
        );
    }

    return (
        <>
            {selectedBank ? (
                <ConnectBank
                    selectedBank={selectedBank}
                    unselectBank={unselectBank}
                    linkingForBankVerification={linkingForBankVerification}
                />
            ) : (
                <ChooseBank
                    selectBank={selectBank}
                    linkingForBankVerification={linkingForBankVerification}
                    isBankEvidence={isBankEvidence}
                    linkedAccounts={linkedAccounts}
                    onOpenShareableLink={onOpenShareableLink}
                    trackingSource={trackingSource}
                    isFundingRequirementsRedesign={
                        isFundingRequirementsRedesign
                    }
                />
            )}
        </>
    );
};
